import React, { useEffect, useRef, useState } from 'react';

import { useAppDispatch, useAppSelector } from 'app/config/store';

import { Button, Checkbox, Col, Form, Input, InputNumber, Row, Select, Spin } from 'antd';
import TextArea from 'antd/es/input/TextArea';
import Title from 'antd/es/typography/Title';
import { APP_LOCAL_DATE_FORMAT_PAYLOAD } from 'app/config/constants';
import { checkInKrQuantiMonth, checkInKrQuantiQuarter, checkInQuantitativeMidYear, checkInQuantitativeMidYearAdjustment, getKrQuantiCheckInMidYear, reset } from 'app/entities/checkIn/checkIn.reducer';
import { getBoxWorkStatus } from 'app/entities/common/common.reducer';
import { checkInKrQuantiAdjust, getAdjustmentMidYearQuantitativeByKrId, resetKrQuantitative } from 'app/entities/kr/kr-quantitative.reducer';
import ObjectiveUpdate from 'app/entities/objective/form/objective-update';
import AdjustObjectiveUpdate from 'app/entities/objective/form/objective-update-adjustment';
import { StatusType } from 'app/shared/model/enum/status.enum';
import { displayPercent, percent } from 'app/shared/util/percent';
import { filterOption } from 'app/shared/util/select-filter';
import dayjs from 'dayjs';
import * as _ from 'lodash';
import { formatNumber, parseNumber } from 'app/shared/util/help';
import { getEntity as getDetailObject } from 'app/entities/objective/objective.reducer';
import { TrendingTypes } from 'app/shared/model/enum/trending.enum';
import { KrTypes } from 'app/shared/model/enum/kr.enum';
import { EvaluationTypes } from 'app/shared/model/enum/evaluation-type.enum';
import { QuantitativeEvaluationType } from 'app/shared/model/enum/quantitativeEvaluation.enum';
import { log } from 'react-jhipster';

type IReportQualitativeResult = {
    handleClose?: () => void;
    krCheckIn?: any;
    handleNextData: () => void;
    hideNextKr: boolean;
    onClose?: () => void;
    idKrBaseSelected?: string;
    idObjective?: string;
    krTypeRequest?: any;
    planPeriodIdSelected?: string;
    planPeriodType?: any;
    isEdit?: boolean;
    isReadOnly?: boolean;
    handleChangeKRType?: () => void;
    selectedPeriod?: number;
    KrType?: any;
};

export const CopyKRQuantitativeVer = ({ handleClose, krCheckIn, handleNextData, hideNextKr, onClose, idKrBaseSelected, idObjective, krTypeRequest, planPeriodIdSelected, planPeriodType, isEdit, isReadOnly, handleChangeKRType, selectedPeriod, KrType }: IReportQualitativeResult) => {
    const dispatch = useAppDispatch();
    const [form] = Form.useForm();
    const filters = useAppSelector(state => state.filters.orgCheckIn);
    const objectiveEntity = useAppSelector(state => state.objective.entity);
    const workStatusList = useAppSelector(state => state.common.workStatus);
    const entity = useAppSelector(state => state.checkIn.entity);
    const adjustmentMidYearQuantitative = useAppSelector(state => state.krQuantitative.adjustmentMidYearQuantitative);
    const loadingAdjustmentMidYearQuantitative = useAppSelector(state => state.krQuantitative.loadingAdjustmentMidYearQuantitative);
    const [compareAdjustmentYear, setCompareAdjustmentYear] = useState([]);
    const [isOpenAdjustmentModel, setOpenAdjustmentModel] = useState(false);
    const [isOpenModalFormKr, setIsOpenModalFormKr] = useState(false);
    const [isOpenModalFormObjective, setIsOpenModalFormObjective] = useState(false);
    const [isUpdating, setUpdating] = useState(false);
    const modalContentRef = useRef(null);

    const [adjustmentValue, setAdjustmentValue] = useState(entity?.adjustment?.isAdjustment === true ? 'adjustment' : 'noAdjustment');
    const [isAdjustment, setIsAdjustment] = useState<string>(entity?.adjustment?.isAdjustment === true ? 'adjustment' : 'noAdjustment');

    useEffect(() => {
        if (isUpdating) {
            handleClose();
        }
    }, [isUpdating]);

    // watch values form
    const workStatusMonthValues = Form.useWatch('workStatusMonth', form);
    const metricValueMonthValues = Form.useWatch('metricValueMonth', form);
    const metricValueQuarterValues = Form.useWatch('metricValueQuarter', form);
    const accumulateResultValues = Form.useWatch('accumulateResult', form);
    const workStatusQuarterValues = Form.useWatch('workStatusQuarter', form);
    const metricValueYearValues = Form.useWatch('metricValue-0', form);
    const metricValueFirstValues = Form.useWatch('metricValue-1', form);
    const metricValueSecondValues = Form.useWatch('metricValue-2', form);
    const metricValueThirdValues = Form.useWatch('metricValue-3', form);
    const metricValueJulValues = Form.useWatch('metricValue-4', form);
    const metricValueAugValues = Form.useWatch('metricValue-5', form);
    const metricValueSepValues = Form.useWatch('metricValue-6', form);
    const metricValueFourthValues = Form.useWatch('metricValue-7', form);
    const metricValueOctValues = Form.useWatch('metricValue-8', form);
    const metricValueNovValues = Form.useWatch('metricValue-9', form);
    const metricValueDecValues = Form.useWatch('metricValue-10', form);


    useEffect(() => {
        if (krCheckIn && filters) {
            innitData();
        }
    }, [krCheckIn, filters]);


    useEffect(() => {
        if (adjustmentMidYearQuantitative) {
            if (adjustmentMidYearQuantitative) {
                form.setFieldValue('adjustmentReason', adjustmentMidYearQuantitative?.adjustmentReason)
                form.setFieldValue('adjustmentIssue', adjustmentMidYearQuantitative?.adjustmentIssue)
                form.setFieldValue('adjustmentNote', adjustmentMidYearQuantitative?.adjustmentNote)
                form.setFieldValue('adjustmentSolution', adjustmentMidYearQuantitative?.adjustmentSolution)
            }
        }
    }, [adjustmentMidYearQuantitative]);



    useEffect(() => {
        if (krCheckIn?.krType === KrTypes.AccumulateQuantitative) {
            if (entity?.keyResultYear?.metricValue !== 0) {
                const result = displayPercent(
                    calculatorPercentByTrending(entity?.keyResultQuarter?.metricType, accumulateResultValues, entity?.keyResultYear?.metricValue),
                );
                if (_.isInteger(result)) form.setFieldValue('accumulatePoint', result);
                else form.setFieldValue('accumulatePoint', result.toFixed(2));
            }
        }
    }, [accumulateResultValues]);

    // tự động tính giá trị điều chỉnh của các tháng
    useEffect(() => {
        if (krCheckIn?.krType === KrTypes.AccumulateQuantitative) {
            const valueYear =
                (metricValueYearValues ?? 0) - ((metricValueFirstValues ?? 0) + (metricValueSecondValues ?? 0) + (metricValueThirdValues ?? 0));
            if (_.isInteger(valueYear)) {
                form.setFieldValue('metricValue-7', valueYear);
                handleChangeAdjustmentYear(valueYear, 7);
            } else {
                const roundedValue = Number(valueYear.toFixed(2));
                form.setFieldValue('metricValue-7', roundedValue);
                handleChangeAdjustmentYear(roundedValue, 7);
            }
        }
    }, [metricValueYearValues, metricValueFirstValues, metricValueSecondValues, metricValueThirdValues]);

    useEffect(() => {
        if (krCheckIn?.krType === KrTypes.AccumulateQuantitative) {
            const sepValue = (metricValueThirdValues ?? 0) - (metricValueJulValues ?? 0) - (metricValueAugValues ?? 0);

            // Đảm bảo giá trị không bị undefined
            const safeThirdValue = metricValueThirdValues ?? 0;
            const safeJulValue = metricValueJulValues ?? 0;
            const safeAugValue = metricValueAugValues ?? 0;

            // Chỉ tính toán khi có ít nhất một giá trị thay đổi
            if (safeThirdValue !== 0 || safeJulValue !== 0 || safeAugValue !== 0) {
                const sepValue = safeThirdValue - safeJulValue - safeAugValue;
                if (_.isInteger(sepValue)) {
                    form.setFieldValue('metricValue-6', sepValue);
                    handleChangeAdjustmentYear(sepValue, 6);
                } else {
                    const roundedValue = Number(sepValue.toFixed(2));
                    form.setFieldValue('metricValue-6', roundedValue);
                    handleChangeAdjustmentYear(roundedValue, 6);
                }
            }
        }
    }, [metricValueThirdValues, metricValueJulValues, metricValueAugValues]);

    useEffect(() => {
        if (krCheckIn?.krType === KrTypes.AccumulateQuantitative) {
            const decValue = (metricValueFourthValues ?? 0) - (metricValueOctValues ?? 0) - (metricValueNovValues ?? 0);
            if (_.isInteger(decValue)) {
                form.setFieldValue('metricValue-10', decValue);
                handleChangeAdjustmentYear(decValue, 10);
            } else {
                const roundedValue = Number(decValue.toFixed(2));
                form.setFieldValue('metricValue-10', roundedValue);
                handleChangeAdjustmentYear(roundedValue, 10);
            }
        }
    }, [metricValueFourthValues, metricValueOctValues, metricValueNovValues]);

    useEffect(() => {
        const newCompareAdjustmentYear = [...compareAdjustmentYear];

        handleCompareInit(metricValueYearValues, 0, newCompareAdjustmentYear)
        handleCompareInit(metricValueFirstValues, 1, newCompareAdjustmentYear)
        handleCompareInit(metricValueSecondValues, 2, newCompareAdjustmentYear)
        handleCompareInit(metricValueThirdValues, 3, newCompareAdjustmentYear)
        handleCompareInit(metricValueJulValues, 4, newCompareAdjustmentYear)
        handleCompareInit(metricValueAugValues, 5, newCompareAdjustmentYear)
        handleCompareInit(metricValueSepValues, 6, newCompareAdjustmentYear)
        handleCompareInit(metricValueFourthValues, 7, newCompareAdjustmentYear)
        handleCompareInit(metricValueOctValues, 8, newCompareAdjustmentYear)
        handleCompareInit(metricValueNovValues, 9, newCompareAdjustmentYear)
        handleCompareInit(metricValueDecValues, 10, newCompareAdjustmentYear)
    }, [metricValueSecondValues, metricValueFirstValues, metricValueJulValues, metricValueAugValues, metricValueSepValues, metricValueFourthValues, metricValueYearValues, metricValueThirdValues, metricValueOctValues, metricValueNovValues, metricValueDecValues]);

    useEffect(() => {
        setAdjustmentValue(entity?.adjustment?.isAdjustment === true ? 'adjustment' : 'noAdjustment');
    }, [entity]);

    const innitData = () => {
        dispatch(getBoxWorkStatus({ statusType: 1 }));
        dispatch(getKrQuantiCheckInMidYear({ krId: krCheckIn?.id, planPeriodId: filters?.planPeriodId }));
    };

    const handleCompareInit = (value, index, array) => {
        if (!adjustmentMidYearQuantitative?.krApproved?.[index]?.metricValue) {
            return;
        }
        array[index] = displayPercent(
            calculatorPercentByTrending(adjustmentMidYearQuantitative?.krApproved[index]?.metricType, value, adjustmentMidYearQuantitative?.krApproved[index].oldMetricValue)
        );
        setCompareAdjustmentYear(array);
    }

    const calculatorPercentByTrending = (calculation, numerator, denominator): number => {
        if (calculation === TrendingTypes.Above) {
            if (denominator > 0) return (numerator ?? 0) / denominator;
            return 0;
        }
        else {
            if (numerator > 0) return denominator / numerator;
            return 0;
        }
    }

    const handleChangeAdjustmentYear = (value, index) => {
        const newCompareAdjustmentYear = [...compareAdjustmentYear];

        // Cập nhật giá trị so sánh
        newCompareAdjustmentYear[index] = displayPercent(
            calculatorPercentByTrending(
                adjustmentMidYearQuantitative?.krApproved[index]?.metricType,
                value,
                adjustmentMidYearQuantitative?.krApproved[index].oldMetricValue
            )
        );

        // Cập nhật state
        setCompareAdjustmentYear(newCompareAdjustmentYear);

        // Tự động tính toán các giá trị phụ thuộc
        if (index === 4 || index === 5) { // Nếu thay đổi tháng 7 hoặc 8
            const safeThirdValue = form.getFieldValue('metricValue-3') ?? 0;
            const safeJulValue = form.getFieldValue('metricValue-4') ?? 0;
            const safeAugValue = form.getFieldValue('metricValue-5') ?? 0;

            const sepValue = safeThirdValue - safeJulValue - safeAugValue;
            const roundedValue = Number(sepValue.toFixed(2));

            form.setFieldValue('metricValue-6', roundedValue);

            // Cập nhật giá trị so sánh cho tháng 9
            newCompareAdjustmentYear[6] = displayPercent(
                calculatorPercentByTrending(
                    adjustmentMidYearQuantitative?.krApproved[6]?.metricType,
                    roundedValue,
                    adjustmentMidYearQuantitative?.krApproved[6].oldMetricValue
                )
            );
            setCompareAdjustmentYear(newCompareAdjustmentYear);
        }

        // Xử lý tự động tính toán tháng 12 khi tháng 10 hoặc 11 thay đổi
        if (index === 8 || index === 9) { // Nếu thay đổi tháng 10 hoặc 11
            const safeFourthValue = form.getFieldValue('metricValue-7') ?? 0;
            const safeOctValue = form.getFieldValue('metricValue-8') ?? 0;
            const safeNovValue = form.getFieldValue('metricValue-9') ?? 0;

            const decValue = safeFourthValue - safeOctValue - safeNovValue;
            const roundedValue = Number(decValue.toFixed(2));

            form.setFieldValue('metricValue-10', roundedValue);

            // Cập nhật giá trị so sánh cho tháng 12
            newCompareAdjustmentYear[10] = displayPercent(
                calculatorPercentByTrending(
                    adjustmentMidYearQuantitative?.krApproved[10]?.metricType,
                    roundedValue,
                    adjustmentMidYearQuantitative?.krApproved[10].oldMetricValue
                )
            );
            setCompareAdjustmentYear(newCompareAdjustmentYear);
        }
    };

    const handleOpenModalAdjustmentObjective = () => {
        setOpenAdjustmentModel(true);
    };

    const handleCloseModalAdjustmentObjective = (reload) => {
        setOpenAdjustmentModel(false);
        if (reload) {
            dispatch(getDetailObject(adjustmentMidYearQuantitative?.objective?.id))
        }
    };

    const MapperPayload = (values: any) => {
        const {
            workStatusMonth,
            metricValueMonth,
            unFinishNoteMonth,
            workStatusQuarter,
            metricValueQuarter,
            unFinishNoteQuarter,
            accumulateResult,
            accumulatePoint,
            noteQuarter,
            adjustmentSolution,
            adjustmentReason,
            adjustmentIssue,
            adjustmentNote,
            sendingNotification,
            reportSchedularId,
            estimatePointMonth,
            estimatePointQuarter,
            reportScheduleName,
            planPeriodName,
            ...remainingValues
        } = values;
        // Khởi tạo mảng khóa
        const keys = Object.keys(remainingValues);

        // Chia mảng thành các nhóm nhỏ, mỗi nhóm có 3 phần tử
        const groupedKeys = _.chunk(keys, 1);
        const subs = _.map(groupedKeys, group => {
            const mapper = _.map(group, key => {
                return remainingValues[key];
            });
            return _.zipObject(['metricValue'], mapper);
        });
        const combinedSubs: any = subs.map((item, index) => {
            if (item.metricValue !== null) {
                return {
                    ...item,
                    planPeriodId: adjustmentMidYearQuantitative?.krApproved[index]?.planPeriodId,
                    startDate: dayjs(adjustmentMidYearQuantitative?.krApproved[index]?.startDate).format(APP_LOCAL_DATE_FORMAT_PAYLOAD),
                    dueDate: dayjs(adjustmentMidYearQuantitative?.krApproved[index]?.dueDate).format(APP_LOCAL_DATE_FORMAT_PAYLOAD),
                };
            }
        });
        const valueAdjustment = {
            solution: adjustmentSolution,
            reason: adjustmentReason,
            issue: adjustmentIssue,
            krId: krCheckIn?.id,
            krAdjustmentNote: adjustmentNote,
            sendingNotification,
            subs: _.filter(combinedSubs, (o) => { return o !== null && o !== undefined }),
        };
        return { valueAdjustment };
    };
    const handleSubmit = values => {
        const { valueAdjustment } = MapperPayload(values);
        setUpdating(true);
        dispatch(checkInQuantitativeMidYearAdjustment({ krId: idKrBaseSelected, adjustment: valueAdjustment })).then(response => {
            const isFailed = _.some(response, (o: any) => {
                return !o.payload;
            });
            if (isFailed) return;
            // Fetch new data after successful save
            dispatch(getAdjustmentMidYearQuantitativeByKrId({ krId: idKrBaseSelected, planPeriodId: filters?.planPeriodId }));
            handleClose();
        })
            .catch(() => {
                return;
            })
            .finally(() => {
                setUpdating(false);
                dispatch(resetKrQuantitative());
            })
            .catch(() => {
                return;
            });
    };

    const handleNextKr = () => {
        form.validateFields().then(values => {
            const { valueAdjustment } = MapperPayload(values);
            setUpdating(true);
            Promise.all([
                dispatch(checkInKrQuantiAdjust(valueAdjustment)),
            ])
                .then(response => {
                    const isFailed = _.some(response, o => {
                        return !o.payload;
                    });
                    if (isFailed) return;
                    form.scrollToField('reportScheduleName');
                    form.resetFields();
                    dispatch(reset());
                    handleNextData();
                })
                .catch(() => {
                    return;
                })
                .finally(() => {
                    setUpdating(false);
                })
                .catch(() => {
                    return;
                });
        }).catch(() => {
            return;
        });
    };

    const handleEditKr = () => {
        setIsOpenModalFormKr(true);
    };

    const handleCloseModelKr = () => {
        setIsOpenModalFormKr(false);
    };

    const handleEditObjective = () => {
        setIsOpenModalFormObjective(true);
    };

    const handleCloseModelObjective = () => {
        setIsOpenModalFormObjective(false);
    };

    const renderNameAdjustment = (index: number, value: string) => {
        switch (index) {
            case 0:
                return `Dự phóng ${value}`
            case 1:
                return `Thực hiện ${value}`
            case 2:
                return `Thực hiện ${value}`
            case 3:
                return `Kế hoạch ${value}`
            case 7:
                return `Kế hoạch ${value}`
            case 8:
                return `${value}`
            case 9:
                return `${value}`
            case 10:
                return `${value}`
            default:
                return value.charAt(0).toUpperCase() + value.slice(1);
        }
    }

    const renderNameAdjustmentTarget = (index: number, value: string) => {
        switch (index) {
            case 0:
                return `Kế hoạch ${value}`
            case 1:
                return `Kế hoạch ${value}`
            case 2:
                return `Kế hoạch ${value}`
            case 3:
                return `Kế hoạch ${value}`
            case 4:
                return `${value.charAt(0).toUpperCase() + value.slice(1)}`
            case 5:
                return `${value.charAt(0).toUpperCase() + value.slice(1)}`
            case 6:
                return `${value.charAt(0).toUpperCase() + value.slice(1)}`
            case 7:
                return `Kế hoạch ${value}`
            case 8:
                return `${value.charAt(0).toUpperCase() + value.slice(1)}`
            case 9:
                return `${value.charAt(0).toUpperCase() + value.slice(1)}`
            case 10:
                return `${value.charAt(0).toUpperCase() + value.slice(1)}`
            case 11:
                return `${value.charAt(0).toUpperCase() + value.slice(1)}`
            case 12:
                return `Kế hoạch ${value}`

            default:
                return value;
        }
    }

    const handleChangeAdjustment = (value: string) => {
        setAdjustmentValue(value);
        setIsAdjustment(value);
    }

    useEffect(() => {
        dispatch(getAdjustmentMidYearQuantitativeByKrId({ krId: idKrBaseSelected, planPeriodId: filters?.planPeriodId }));
    }, [dispatch, idKrBaseSelected, filters?.planPeriodId]);

    return (
        <Spin spinning={loadingAdjustmentMidYearQuantitative}>
            <Form form={form} onFinish={handleSubmit} layout="vertical">
                <Row>
                    <Col className="fw-bold h3" md={24}>
                        ĐIỀU CHỈNH KẾ HOẠCH NĂM {entity?.adjustment?.year}
                    </Col>
                </Row>

                <Row>
                    <Col md={11}>
                        <Form.Item label="Nội dung mục tiêu">
                            <TextArea rows={1} className="w-100" disabled value={adjustmentMidYearQuantitative?.objective?.purpose} size="large" />
                        </Form.Item>
                    </Col>
                    <Col md={1} />
                    <Col md={3}>
                        <Form.Item label="Lĩnh vực">
                            <Input className="w-100" disabled value={adjustmentMidYearQuantitative?.objective?.fieldName} size="large" />
                        </Form.Item>
                    </Col>
                    <Col md={1} />
                    <Col md={3}>
                        <Form.Item label="Dự án">
                            <Input className="w-100" disabled value={adjustmentMidYearQuantitative?.objective?.projectName} size="large" />
                        </Form.Item>
                    </Col>
                    <Col md={1} />
                    <Col md={4}>
                        <Form.Item label="Mảng công việc">
                            <Input className="w-100" disabled value={adjustmentMidYearQuantitative?.objective?.workTypeName} size="large" />
                        </Form.Item>
                    </Col>
                </Row>
                <Row>
                    <Form.Item>
                        <span className="cursor-pointer text-primary" onClick={() => handleOpenModalAdjustmentObjective()}>
                            {`> Điều chỉnh mục tiêu`}
                        </span>
                    </Form.Item>
                </Row>
                <Row>
                    <Col className="fw-bold h4" md={24}>
                        Kết quả cần đạt được
                    </Col>
                </Row>
                <Row className='mt-3'>
                    <Col md={8}>
                        <Row>
                            <Col md={8} />
                            <Col md={1} />
                            <Col className="fw-bold" md={15}>
                                Chỉ tiêu đã duyệt
                            </Col>
                        </Row>
                        {adjustmentMidYearQuantitative?.krApproved?.map((x, index) => {
                            return (
                                <Row className="d-flex align-items-center" key={`approve-${index}`}>
                                    <Col md={8}>
                                        <span className="fw-bold">{renderNameAdjustmentTarget(index, x.name)}</span>
                                    </Col>
                                    <Col md={1} />
                                    <Col className="mt-2" md={15}>
                                        <Form.Item>
                                            {
                                                <InputNumber formatter={formatNumber} parser={parseNumber} disabled className="w-100" value={x.oldMetricValue} size="large" />
                                            }
                                        </Form.Item>
                                    </Col>
                                </Row>
                            );
                        })}
                    </Col>
                    <Col md={1} />
                    <Col md={8}>
                        <Row>
                            <Col md={8} />
                            <Col md={1} />
                            <Col className="fw-bold" md={15}>
                                Chỉ tiêu điều chỉnh
                            </Col>
                        </Row>
                        {adjustmentMidYearQuantitative?.krApproved?.map((x, index) => {
                            return (
                                <Row className="d-flex align-items-center" key={`adjust-${index}`}>
                                    <Col md={8} className='text-end'>
                                        <span className="fw-bold mt-2">
                                            {renderNameAdjustment(index, x.name)}
                                        </span>
                                    </Col>
                                    <Col md={1} />
                                    <Col className="mt-2" md={15}>
                                        <Form.Item
                                            initialValue={x?.metricValue} rules={[
                                                { required: index === 0, message: "Vui lòng nhập giá trị" },

                                            ]} name={`metricValue-${index}`}>
                                            <InputNumber
                                                parser={parseNumber}
                                                formatter={formatNumber}
                                                disabled={(krCheckIn?.krType === KrTypes.AccumulateQuantitative ? (index === 6) : undefined) || index === 1 || index === 2 || index === 10 || index === 6 || index === 7}
                                                className="w-100"
                                                step={0.01} precision={2}
                                                onChange={e => {
                                                    handleChangeAdjustmentYear(e, index);
                                                }}
                                                size="large"
                                            />
                                        </Form.Item>
                                    </Col>
                                </Row>
                            );
                        })}
                    </Col>
                    <Col md={1} />
                    <Col md={5}>
                        <Row>
                            <Col className="fw-bold" md={24}>
                                So sánh
                            </Col>
                        </Row>

                        {adjustmentMidYearQuantitative?.krApproved?.map((x, index) => {
                            return (
                                <Row className="mt-2" key={`compare-${index}`}>
                                    <Col md={24}>
                                        <Form.Item>
                                            {
                                                <InputNumber
                                                    parser={parseNumber}
                                                    formatter={formatNumber}
                                                    disabled
                                                    className="w-100"
                                                    value={compareAdjustmentYear[index]?.toFixed(2)}
                                                    size="large"
                                                    addonAfter="%"
                                                />
                                            }
                                        </Form.Item>
                                    </Col>
                                </Row>
                            );
                        })}
                    </Col>
                </Row>

                <Row className='mt-3'>
                    <Col md={24}>
                        <Form.Item
                            label={<span className="fw-bold">Lý do điều chỉnh kế hoạch</span>}
                            name={'adjustmentReason'}
                        >
                            <TextArea rows={3} placeholder="Nhập lý do điều chỉnh kế hoạch" size="large" />
                        </Form.Item>
                    </Col>
                </Row>
                <Row className='mt-3'>
                    <Col md={11}>
                        <Form.Item label={<span className="fw-bold">Khó khăn & nguyên nhân</span>} name={'adjustmentIssue'}>
                            <TextArea rows={6} placeholder="Nhập khó khăn & nguyên nhân" size="large" />
                        </Form.Item>
                    </Col>
                    <Col md={2} />
                    <Col md={11}>
                        <Form.Item label={<span className="fw-bold">Giải pháp và kiến nghị</span>} name={'adjustmentSolution'}>
                            <TextArea rows={6} placeholder="Nhập giải pháp và kiến nghị" size="large" />
                        </Form.Item>
                    </Col>
                </Row>
                <Row className='mt-3'>
                    <Col md={24}>
                        <Form.Item label={<span className="fw-bold">Tài liệu đính kèm về kết quả thực hiện (link)</span>} name={'adjustmentNote'}>
                            <TextArea rows={3} placeholder="Nhập tài liệu đính kèm về kết quả thực hiện" size="large" />
                        </Form.Item>
                        <Form.Item valuePropName="checked" name={'sendingNotification'}>
                            <Checkbox>Gửi thông báo đến người nhận</Checkbox>
                        </Form.Item>
                    </Col>
                </Row>

                <Form.Item>
                    <Row className="d-flex gap-3 mt-3" justify="end">
                        <Col>
                            <Button
                                className="secondary"
                                onClick={() => {
                                    handleClose();
                                }}
                            >
                                Hủy
                            </Button>
                        </Col>
                        <Col>
                            <Button className="primary" htmlType="submit" disabled={isUpdating}>
                                Lưu
                            </Button>
                        </Col>
                    </Row>
                </Form.Item>
                {isOpenAdjustmentModel && (
                    <AdjustObjectiveUpdate isOpen={isOpenAdjustmentModel} onClose={handleCloseModalAdjustmentObjective} id={adjustmentMidYearQuantitative?.objective?.id} />
                )}
                {isOpenModalFormObjective && (
                    <ObjectiveUpdate isOpen={isOpenModalFormObjective} id={adjustmentMidYearQuantitative?.objective?.id} onClose={handleCloseModelObjective} />
                )}
            </Form>
        </Spin>
    );
};

export default CopyKRQuantitativeVer;

